export const voiceLineStorageKey = (accountId, userId) =>
  `cloudchat:voice:last-line:${accountId}:${userId}`;

export const getLastVoiceLine = (accountId, userId) => {
  try {
    const raw = window.localStorage.getItem(
      voiceLineStorageKey(accountId, userId)
    );
    const inboxId = Number(raw);
    return raw && Number.isInteger(inboxId) && inboxId > 0 ? inboxId : null;
  } catch {
    return null;
  }
};

export const setLastVoiceLine = (accountId, userId, inboxId) => {
  try {
    window.localStorage.setItem(
      voiceLineStorageKey(accountId, userId),
      String(inboxId)
    );
    return true;
  } catch {
    return false;
  }
};

export const pickDefaultVoiceLine = (lines, accountId, userId) => {
  if (!Array.isArray(lines) || lines.length === 0) return null;
  if (lines.length === 1) return lines[0];
  const lastInboxId = getLastVoiceLine(accountId, userId);
  const last = lines.find(line => line.inbox_id === lastInboxId);
  if (last) return last;
  return lines.reduce(
    (lowest, line) => (line.inbox_id < lowest.inbox_id ? line : lowest),
    lines[0]
  );
};
